export const CreativeServicesAnimation = {
  nm: "02",
  h: 281,
  w: 281,
  meta: { g: "LottieFiles Figma v91" },
  layers: [
    {
      ty: 4,
      nm: "Group 2688",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [142.5, 81.61],
              t: 0,
            },
            { s: [143.41, 67.72], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [26.89], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Vector 3 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [1, 18.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.7, 57.57] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 35.73],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 35.73],
                      [2, 35.73],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 35.73],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 35.73],
                      [2, 35.73],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 28.208],
                      [2, 31.969],
                      [0, 31.969],
                      [0, 28.208],
                      [2, 28.208],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 28.21],
                      [2, 31.97],
                      [0, 31.97],
                      [0, 28.21],
                      [2, 28.21],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.686],
                      [2, 24.446],
                      [0, 24.446],
                      [0, 20.686],
                      [2, 20.686],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.69],
                      [2, 24.45],
                      [0, 24.45],
                      [0, 20.69],
                      [2, 20.69],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 13.163],
                      [2, 16.925],
                      [0, 16.925],
                      [0, 13.163],
                      [2, 13.163],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 13.16],
                      [2, 16.92],
                      [0, 16.92],
                      [0, 13.16],
                      [2, 13.16],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 5.642],
                      [2, 9.402],
                      [0, 9.402],
                      [0, 5.642],
                      [2, 5.642],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 5.64],
                      [2, 9.4],
                      [0, 9.4],
                      [0, 5.64],
                      [2, 5.64],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 1.881],
                      [0, 1.881],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 1.88],
                      [0, 1.88],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 2,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Vector 2 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33, 10.41] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 29.51] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.198, 18.517],
                      [34.315, 17.868],
                      [35.32, 19.596],
                      [33.206, 20.827],
                      [31.068, 19.599],
                      [31.567, 18.732],
                      [32.065, 17.865],
                      [33.198, 18.517],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.2, 18.52],
                      [34.31, 17.87],
                      [35.32, 19.6],
                      [33.21, 20.83],
                      [31.07, 19.6],
                      [31.57, 18.73],
                      [32.07, 17.87],
                      [33.2, 18.52],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [28.795, 15.984],
                      [27.798, 17.719],
                      [24.528, 15.838],
                      [25.524, 14.105],
                      [28.795, 15.984],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [28.79, 15.98],
                      [27.8, 17.72],
                      [24.53, 15.84],
                      [25.52, 14.1],
                      [28.79, 15.98],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [41.779, 15.835],
                      [38.55, 17.716],
                      [37.544, 15.987],
                      [40.773, 14.106],
                      [41.779, 15.835],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [41.78, 15.84],
                      [38.55, 17.72],
                      [37.54, 15.99],
                      [40.77, 14.11],
                      [41.78, 15.84],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [22.254, 12.224],
                      [21.258, 13.957],
                      [17.987, 12.077],
                      [18.984, 10.343],
                      [22.254, 12.224],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [22.25, 12.22],
                      [21.26, 13.96],
                      [17.99, 12.08],
                      [18.98, 10.34],
                      [22.25, 12.22],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [48.238, 12.074],
                      [45.009, 13.955],
                      [44.003, 12.227],
                      [47.232, 10.346],
                      [48.238, 12.074],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [48.24, 12.07],
                      [45.01, 13.96],
                      [44, 12.23],
                      [47.23, 10.35],
                      [48.24, 12.07],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.714, 8.463],
                      [15.215, 9.329],
                      [14.717, 10.196],
                      [11.446, 8.315],
                      [12.443, 6.582],
                      [15.714, 8.463],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.71, 8.46],
                      [15.21, 9.33],
                      [14.72, 10.2],
                      [11.45, 8.32],
                      [12.44, 6.58],
                      [15.71, 8.46],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [54.698, 8.313],
                      [51.468, 10.193],
                      [50.462, 8.465],
                      [53.691, 6.585],
                      [54.698, 8.313],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [54.7, 8.31],
                      [51.47, 10.19],
                      [50.46, 8.46],
                      [53.69, 6.58],
                      [54.7, 8.31],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.173, 4.701],
                      [8.176, 6.436],
                      [4.905, 4.555],
                      [5.403, 3.688],
                      [5.902, 2.821],
                      [9.173, 4.701],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.17, 4.7],
                      [8.18, 6.44],
                      [4.91, 4.55],
                      [5.4, 3.69],
                      [5.9, 2.82],
                      [9.17, 4.7],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [61.157, 4.552],
                      [57.928, 6.433],
                      [56.921, 4.704],
                      [60.15, 2.824],
                      [61.157, 4.552],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [61.16, 4.55],
                      [57.93, 6.43],
                      [56.92, 4.7],
                      [60.15, 2.82],
                      [61.16, 4.55],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.632, 0.94],
                      [1.635, 2.675],
                      [0, 1.734],
                      [0.996, 0],
                      [2.632, 0.94],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.63, 0.94],
                      [1.63, 2.67],
                      [0, 1.73],
                      [1, 0],
                      [2.63, 0.94],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [66.001, 1.731],
                      [64.387, 2.672],
                      [63.38, 0.943],
                      [64.995, 0.003],
                      [66.001, 1.731],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [66, 1.73],
                      [64.39, 2.67],
                      [63.38, 0.94],
                      [65, 0],
                      [66, 1.73],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 3,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Vector 1 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.7, 75.22],
                      [34.816, 74.571],
                      [35.822, 76.3],
                      [33.708, 77.53],
                      [31.57, 76.302],
                      [32.069, 75.436],
                      [32.567, 74.568],
                      [33.7, 75.22],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.7, 75.22],
                      [34.82, 74.57],
                      [35.82, 76.3],
                      [33.71, 77.53],
                      [31.57, 76.3],
                      [32.07, 75.44],
                      [32.57, 74.57],
                      [33.7, 75.22],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [29.297, 72.688],
                      [28.3, 74.422],
                      [25.03, 72.541],
                      [26.026, 70.808],
                      [29.297, 72.688],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [29.3, 72.69],
                      [28.3, 74.42],
                      [25.03, 72.54],
                      [26.03, 70.81],
                      [29.3, 72.69],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [42.281, 72.538],
                      [39.052, 74.419],
                      [38.046, 72.69],
                      [41.275, 70.81],
                      [42.281, 72.538],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [42.28, 72.54],
                      [39.05, 74.42],
                      [38.05, 72.69],
                      [41.28, 70.81],
                      [42.28, 72.54],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [22.756, 68.927],
                      [21.76, 70.66],
                      [18.489, 68.78],
                      [19.486, 67.046],
                      [22.756, 68.927],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [22.76, 68.93],
                      [21.76, 70.66],
                      [18.49, 68.78],
                      [19.49, 67.05],
                      [22.76, 68.93],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [48.74, 68.777],
                      [45.511, 70.658],
                      [44.505, 68.93],
                      [47.734, 67.049],
                      [48.74, 68.777],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [48.74, 68.78],
                      [45.51, 70.66],
                      [44.5, 68.93],
                      [47.73, 67.05],
                      [48.74, 68.78],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.216, 65.166],
                      [15.717, 66.032],
                      [15.219, 66.899],
                      [11.948, 65.019],
                      [12.945, 63.285],
                      [16.216, 65.166],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.22, 65.17],
                      [15.72, 66.03],
                      [15.22, 66.9],
                      [11.95, 65.02],
                      [12.95, 63.29],
                      [16.22, 65.17],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [55.2, 65.017],
                      [51.97, 66.897],
                      [50.964, 65.168],
                      [54.193, 63.288],
                      [55.2, 65.017],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [55.2, 65.02],
                      [51.97, 66.9],
                      [50.96, 65.17],
                      [54.19, 63.29],
                      [55.2, 65.02],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.675, 61.404],
                      [8.678, 63.139],
                      [5.407, 61.258],
                      [6.404, 59.524],
                      [9.675, 61.404],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.67, 61.4],
                      [8.68, 63.14],
                      [5.41, 61.26],
                      [6.4, 59.52],
                      [9.67, 61.4],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [61.155, 60.392],
                      [61.659, 61.255],
                      [58.43, 63.136],
                      [57.423, 61.407],
                      [60.652, 59.527],
                      [61.155, 60.392],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [61.16, 60.39],
                      [61.66, 61.25],
                      [58.43, 63.14],
                      [57.42, 61.41],
                      [60.65, 59.53],
                      [61.16, 60.39],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 55.69],
                      [2, 56.991],
                      [3.134, 57.644],
                      [2.137, 59.378],
                      [0, 58.148],
                      [0, 55.69],
                      [2, 55.69],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 55.69],
                      [2, 56.99],
                      [3.13, 57.64],
                      [2.14, 59.38],
                      [0, 58.15],
                      [0, 55.69],
                      [2, 55.69],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 55.69],
                      [67, 58.146],
                      [64.889, 59.375],
                      [63.882, 57.647],
                      [65, 56.995],
                      [65, 55.69],
                      [67, 55.69],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 55.69],
                      [67, 58.15],
                      [64.89, 59.38],
                      [63.88, 57.65],
                      [65, 57],
                      [65, 55.69],
                      [67, 55.69],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 48.168],
                      [2, 51.929],
                      [0, 51.929],
                      [0, 48.168],
                      [2, 48.168],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 48.17],
                      [2, 51.93],
                      [0, 51.93],
                      [0, 48.17],
                      [2, 48.17],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 48.168],
                      [67, 51.929],
                      [65, 51.929],
                      [65, 48.168],
                      [67, 48.168],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 48.17],
                      [67, 51.93],
                      [65, 51.93],
                      [65, 48.17],
                      [67, 48.17],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 40.646],
                      [2, 44.407],
                      [0, 44.407],
                      [0, 40.646],
                      [2, 40.646],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 40.65],
                      [2, 44.41],
                      [0, 44.41],
                      [0, 40.65],
                      [2, 40.65],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 40.646],
                      [67, 44.407],
                      [65, 44.407],
                      [65, 40.646],
                      [67, 40.646],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 40.65],
                      [67, 44.41],
                      [65, 44.41],
                      [65, 40.65],
                      [67, 40.65],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 33.124],
                      [2, 36.885],
                      [0, 36.885],
                      [0, 33.124],
                      [2, 33.124],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 33.12],
                      [2, 36.88],
                      [0, 36.88],
                      [0, 33.12],
                      [2, 33.12],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 33.124],
                      [67, 36.885],
                      [65, 36.885],
                      [65, 33.124],
                      [67, 33.124],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 33.12],
                      [67, 36.88],
                      [65, 36.88],
                      [65, 33.12],
                      [67, 33.12],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 25.602],
                      [2, 29.363],
                      [0, 29.363],
                      [0, 25.602],
                      [2, 25.602],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 25.6],
                      [2, 29.36],
                      [0, 29.36],
                      [0, 25.6],
                      [2, 25.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 25.602],
                      [67, 29.363],
                      [65, 29.363],
                      [65, 25.602],
                      [67, 25.602],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 25.6],
                      [67, 29.36],
                      [65, 29.36],
                      [65, 25.6],
                      [67, 25.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.635, 19.021],
                      [3.134, 19.887],
                      [2, 20.538],
                      [2, 21.841],
                      [0, 21.841],
                      [0, 19.382],
                      [0.502, 19.094],
                      [2.137, 18.153],
                      [2.635, 19.021],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.63, 19.02],
                      [3.13, 19.89],
                      [2, 20.54],
                      [2, 21.84],
                      [0, 21.84],
                      [0, 19.38],
                      [0.5, 19.09],
                      [2.14, 18.15],
                      [2.63, 19.02],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [66.503, 19.096],
                      [67, 19.386],
                      [67, 21.841],
                      [65, 21.841],
                      [65, 20.534],
                      [63.882, 19.884],
                      [64.889, 18.156],
                      [66.503, 19.096],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [66.5, 19.1],
                      [67, 19.39],
                      [67, 21.84],
                      [65, 21.84],
                      [65, 20.53],
                      [63.88, 19.88],
                      [64.89, 18.16],
                      [66.5, 19.1],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.675, 16.126],
                      [6.404, 18.007],
                      [5.407, 16.273],
                      [8.678, 14.393],
                      [9.675, 16.126],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.67, 16.13],
                      [6.4, 18.01],
                      [5.41, 16.27],
                      [8.68, 14.39],
                      [9.67, 16.13],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [61.659, 16.275],
                      [60.652, 18.004],
                      [57.423, 16.123],
                      [58.43, 14.395],
                      [61.659, 16.275],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [61.66, 16.28],
                      [60.65, 18],
                      [57.42, 16.12],
                      [58.43, 14.39],
                      [61.66, 16.28],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.216, 12.365],
                      [12.945, 14.245],
                      [12.446, 13.379],
                      [11.948, 12.512],
                      [15.219, 10.631],
                      [16.216, 12.365],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.22, 12.37],
                      [12.95, 14.25],
                      [12.45, 13.38],
                      [11.95, 12.51],
                      [15.22, 10.63],
                      [16.22, 12.37],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [55.2, 12.515],
                      [54.193, 14.243],
                      [50.964, 12.362],
                      [51.97, 10.634],
                      [55.2, 12.515],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [55.2, 12.51],
                      [54.19, 14.24],
                      [50.96, 12.36],
                      [51.97, 10.63],
                      [55.2, 12.51],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [22.756, 8.604],
                      [19.486, 10.484],
                      [18.489, 8.751],
                      [21.76, 6.87],
                      [22.756, 8.604],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [22.76, 8.6],
                      [19.49, 10.48],
                      [18.49, 8.75],
                      [21.76, 6.87],
                      [22.76, 8.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [48.74, 8.753],
                      [47.734, 10.481],
                      [44.505, 8.602],
                      [45.511, 6.873],
                      [48.74, 8.753],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [48.74, 8.75],
                      [47.73, 10.48],
                      [44.5, 8.6],
                      [45.51, 6.87],
                      [48.74, 8.75],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [28.799, 3.976],
                      [29.297, 4.843],
                      [26.026, 6.724],
                      [25.03, 4.989],
                      [28.3, 3.109],
                      [28.799, 3.976],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [28.8, 3.98],
                      [29.3, 4.84],
                      [26.03, 6.72],
                      [25.03, 4.99],
                      [28.3, 3.11],
                      [28.8, 3.98],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [42.281, 4.992],
                      [41.275, 6.721],
                      [38.046, 4.84],
                      [39.052, 3.112],
                      [42.281, 4.992],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [42.28, 4.99],
                      [41.28, 6.72],
                      [38.05, 4.84],
                      [39.05, 3.11],
                      [42.28, 4.99],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [35.822, 1.231],
                      [34.816, 2.96],
                      [33.701, 2.311],
                      [32.567, 2.963],
                      [31.57, 1.229],
                      [33.708, 0],
                      [35.822, 1.231],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [35.82, 1.23],
                      [34.82, 2.96],
                      [33.7, 2.31],
                      [32.57, 2.96],
                      [31.57, 1.23],
                      [33.71, 0],
                      [35.82, 1.23],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 4,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Vector 1",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [32.5, 37.61] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.415],
                      [0, 18.805],
                      [32.704, 0],
                      [65, 18.805],
                      [65, 56.415],
                      [32.704, 75.22],
                      [0, 56.415],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.42],
                      [0, 18.81],
                      [32.7, 0],
                      [65, 18.81],
                      [65, 56.42],
                      [32.7, 75.22],
                      [0, 56.42],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 5,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Group 2685",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [145.5, 142.61],
              t: 0,
            },
            { s: [148.33, 147.83], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [-16.91], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 6,
    },
    {
      ty: 4,
      nm: "Vector 3 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [1, 18.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.7, 57.57] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 7,
      parent: 6,
    },
    {
      ty: 4,
      nm: "Vector 2 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33, 10.41] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 29.51] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.198, 18.517],
                      [64.995, 0.003],
                      [66.001, 1.731],
                      [33.206, 20.827],
                      [0, 1.734],
                      [0.996, 0],
                      [33.198, 18.517],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.2, 18.52],
                      [65, 0],
                      [66, 1.73],
                      [33.21, 20.83],
                      [0, 1.73],
                      [1, 0],
                      [33.2, 18.52],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 8,
      parent: 6,
    },
    {
      ty: 4,
      nm: "Vector 1 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 19.386],
                      [67, 58.146],
                      [33.708, 77.53],
                      [0, 58.148],
                      [0, 19.382],
                      [33.708, 0],
                      [67, 19.386],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 19.39],
                      [67, 58.15],
                      [33.71, 77.53],
                      [0, 58.15],
                      [0, 19.38],
                      [33.71, 0],
                      [67, 19.39],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.538],
                      [2, 56.991],
                      [33.7, 75.22],
                      [65, 56.995],
                      [65, 20.534],
                      [33.701, 2.311],
                      [2, 20.538],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.54],
                      [2, 56.99],
                      [33.7, 75.22],
                      [65, 57],
                      [65, 20.53],
                      [33.7, 2.31],
                      [2, 20.54],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 9,
      parent: 6,
    },
    {
      ty: 4,
      nm: "Vector 1",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [32.5, 37.61] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.415],
                      [0, 18.805],
                      [32.704, 0],
                      [65, 18.805],
                      [65, 56.415],
                      [32.704, 75.22],
                      [0, 56.415],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.42],
                      [0, 18.81],
                      [32.7, 0],
                      [65, 18.81],
                      [65, 56.42],
                      [32.7, 75.22],
                      [0, 56.42],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 10,
      parent: 6,
    },
    {
      ty: 4,
      nm: "Group 2686",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [119.5, 119.61],
              t: 0,
            },
            { s: [107.32, 119.47], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [11.06], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 11,
    },
    {
      ty: 4,
      nm: "Vector 3 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [1, 18.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.7, 57.57] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 12,
      parent: 11,
    },
    {
      ty: 4,
      nm: "Vector 2 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33, 10.41] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 29.51] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.198, 18.517],
                      [64.995, 0.003],
                      [66.001, 1.731],
                      [33.206, 20.827],
                      [0, 1.734],
                      [0.996, 0],
                      [33.198, 18.517],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.2, 18.52],
                      [65, 0],
                      [66, 1.73],
                      [33.21, 20.83],
                      [0, 1.73],
                      [1, 0],
                      [33.2, 18.52],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 13,
      parent: 11,
    },
    {
      ty: 4,
      nm: "Vector 1 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 19.386],
                      [67, 58.146],
                      [33.708, 77.53],
                      [0, 58.148],
                      [0, 19.382],
                      [33.708, 0],
                      [67, 19.386],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 19.39],
                      [67, 58.15],
                      [33.71, 77.53],
                      [0, 58.15],
                      [0, 19.38],
                      [33.71, 0],
                      [67, 19.39],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.538],
                      [2, 56.991],
                      [33.7, 75.22],
                      [65, 56.995],
                      [65, 20.534],
                      [33.701, 2.311],
                      [2, 20.538],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.54],
                      [2, 56.99],
                      [33.7, 75.22],
                      [65, 57],
                      [65, 20.53],
                      [33.7, 2.31],
                      [2, 20.54],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 14,
      parent: 11,
    },
    {
      ty: 4,
      nm: "Vector 1",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [32.5, 37.61] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.415],
                      [0, 18.805],
                      [32.704, 0],
                      [65, 18.805],
                      [65, 56.415],
                      [32.704, 75.22],
                      [0, 56.415],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.42],
                      [0, 18.81],
                      [32.7, 0],
                      [65, 18.81],
                      [65, 56.42],
                      [32.7, 75.22],
                      [0, 56.42],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 15,
      parent: 11,
    },
    {
      ty: 4,
      nm: "Group 2687",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [160.5, 116.61],
              t: 0,
            },
            { s: [178, 116.09], t: 75 },
          ],
        },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [36.59], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 16,
    },
    {
      ty: 4,
      nm: "Vector 3 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [1, 18.81] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.7, 57.57] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 0],
                      [2, 37.61],
                      [0, 37.61],
                      [0, 0],
                      [2, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 17,
      parent: 16,
    },
    {
      ty: 4,
      nm: "Vector 2 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33, 10.41] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 29.51] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.198, 18.517],
                      [64.995, 0.003],
                      [66.001, 1.731],
                      [33.206, 20.827],
                      [0, 1.734],
                      [0.996, 0],
                      [33.198, 18.517],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.2, 18.52],
                      [65, 0],
                      [66, 1.73],
                      [33.21, 20.83],
                      [0, 1.73],
                      [1, 0],
                      [33.2, 18.52],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 18,
      parent: 16,
    },
    {
      ty: 4,
      nm: "Vector 1 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [33.5, 38.77] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 19.386],
                      [67, 58.146],
                      [33.708, 77.53],
                      [0, 58.148],
                      [0, 19.382],
                      [33.708, 0],
                      [67, 19.386],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67, 19.39],
                      [67, 58.15],
                      [33.71, 77.53],
                      [0, 58.15],
                      [0, 19.38],
                      [33.71, 0],
                      [67, 19.39],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.538],
                      [2, 56.991],
                      [33.7, 75.22],
                      [65, 56.995],
                      [65, 20.534],
                      [33.701, 2.311],
                      [2, 20.538],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 20.54],
                      [2, 56.99],
                      [33.7, 75.22],
                      [65, 57],
                      [65, 20.53],
                      [33.7, 2.31],
                      [2, 20.54],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0.102, 0.102, 0.102], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 19,
      parent: 16,
    },
    {
      ty: 4,
      nm: "Vector 1",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [32.5, 37.61] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [33.5, 38.77] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.415],
                      [0, 18.805],
                      [32.704, 0],
                      [65, 18.805],
                      [65, 56.415],
                      [32.704, 75.22],
                      [0, 56.415],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 56.42],
                      [0, 18.81],
                      [32.7, 0],
                      [65, 18.81],
                      [65, 56.42],
                      [32.7, 75.22],
                      [0, 56.42],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 20,
      parent: 16,
    },
  ],
  v: "5.7.0",
  fr: 60,
  op: 75.01,
  ip: 0,
  assets: [],
};
